<template>
  <div>
    <div v-if="error" class="text-center my-5">
      <p class="text-secondary">{{$t('common.error_fetch_data')}}</p>
      <p class="text-primary link" href="#" @click.prevent="fetchData">{{$t('common.rfrsh_page')}} <i class="icon fa fa-refresh"></i></p>
    </div>
    <div v-else class="my-5">
      <b-row class="form-group">
        <b-col>
          <label>{{$t('monitoring.cashflow.period_cashflow')}} :</label>
          <b-form-select class="custom-select" required
            v-model="sPeriodCashFlow"
            @change="changeDateCashFlow"
            :options="periodOptions">
          </b-form-select>
        </b-col>
        <b-col>
          <label>{{$t('monitoring.cashflow.period_forecast')}} :</label>
          <b-form-select class="custom-select" required
            v-model="sPeriodPrevision"
            @change="changeDatePrevision"
            :options="periodOptions">
          </b-form-select>
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <BarChart :chartData="chartData" :options="options" v-if="chartData" />
      <div class="text-center" v-else>
        <b-spinner class="greenFont"></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from '@/pages/statistics/components/graphiques/BarChart.vue'
import moment from 'moment'
export default {
  name: 'CashFlowStatistics',
  data () {
    return {
      sPeriodCashFlow: 3,
      sPeriodPrevision: 3,
      periodOptionsNumbers: [3, 6, 9, 12, 18],
      MinMonth: 3,
      MaxMonth: 3,
      rawData: undefined,
      error: false,
      options: {
        indexAxis: 'x',
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          intersect: false
        },
        scales: {
          x: {
            stacked: true
          },
          y: {
            stacked: true
          }
        }
      }
    }
  },
  components: {
    BarChart
  },
  created () {
    this.fetchData()
  },
  methods: {
    changeDateCashFlow (value) {
      this.getMinMonth(value)
      this.fetchData()
    },
    changeDatePrevision (value) {
      this.getMaxMonth(value)
      this.fetchData()
    },
    fetchData () {
      this.rawData = undefined
      const StartDate = moment().subtract(this.MinMonth, 'months')
      const EndDate = moment().add(this.MaxMonth, 'months')
      // console.log(StartDate.format())
      // console.log(EndDate.format())
      this.$engine.monitoring.cashflow.getStatsFormatted(StartDate, EndDate)
      .then(response => {
        // console.log(response)
        if (response.error) {
          this.error = true
        } else {
          this.rawData = response
        }
      })
    },
    getMinMonth (months) {
      // console.log(months)
      this.MinMonth = months
    },
    getMaxMonth (months) {
      // console.log(months)
      this.MaxMonth = months
    }
  },
  computed: {
    chartData () {
      if (!this.rawData) {
        return undefined
      } else {
        return {
          datasets: [{
            type: 'line',
            fill: false,
            label: this.$t('monitoring.cashflow.stats.balance'),
            data: this.rawData.Balance,
            backgroundColor: '#54595E',
            borderColor: '#54595E'
          }, {
            type: 'line',
            fill: false,
            label: this.$t('monitoring.cashflow.stats.balance_prev'),
            data: this.rawData.FuturBalance,
            backgroundColor: '#0d6efd',
            borderColor: '#0d6efd'
          }, {
            type: 'bar',
            label: this.$t('monitoring.cashflow.stats.credit'),
            data: this.rawData.Credit,
            backgroundColor: '#28A745',
            stack: 'credit'
          }, {
            type: 'bar',
            label: this.$t('monitoring.cashflow.stats.debit'),
            data: this.rawData.Debit.map(e => {
              return -e
            }),
            backgroundColor: '#17A2B8',
            stack: 'debit'
          },
          {
            type: 'bar',
            label: this.$t('monitoring.cashflow.stats.credit_prev'),
            data: this.rawData.FuturCredit,
            backgroundColor: '#64da73',
            stack: 'credit'
          },
          {
            type: 'bar',
            label: this.$t('monitoring.cashflow.stats.debit_prev'),
            data: this.rawData.FuturDebit.map(e => {
              return -e
            }),
            backgroundColor: '#60d4ea',
            stack: 'debit'
          }],
          labels: this.rawData.Labels
        }
      }
    },
    periodOptions () {
      return this.periodOptionsNumbers.map(number => {
        return {
          value: number,
          text: `${number} ${this.$t('monitoring.cashflow.month')}`
        }
      })
    }
  }
}
</script>

<style scoped>
.link:hover {
  text-decoration: underline;
  cursor:pointer;
}
.spacer {
  margin-top: 60px;
  margin-bottom: 60px;
}
</style>
